import {
  CommunicationChannel,
  FieldName,
  FormSlug,
  ImplementationGuideForm,
  ResponseFormat,
} from "@/components/ImplementationGuide/types";

const communicationsForm: ImplementationGuideForm = {
  title: "Communications",
  subtitle:
    "Set up communication with teachers and share essential information with them using these templates and examples.",
  slug: FormSlug.Communications,
  form_image: "/images/implementation-guide/Communications.svg",
  form_index: 3,
  form_description: {
    content:
      "We will identify your preferred communication system for sharing information about Newsela with your district.",
    recommendation: "",
  },
  questions: [
    {
      question_index: 1,
      question_text:
        "We recommend communicating with your teachers at least once a month about Newsela. We will provide resources to share with your teachers to support their use of Newsela.",
      sub_prompt:
        "What is the primary communication channel you use at your school/district to communicate with teachers and staff?",
      response_format: ResponseFormat.radiobutton,
      response_fields: {
        textarea_title: "What other communication channel do you use?",
        textarea_placeholder: "Name of communication channel",
        textarea_field_name: FieldName.Communication_Channel_for_Teacher_Other,
        response_options: Object.values(CommunicationChannel),
      },
      is_response_read_only: false,
      field_name: FieldName.Communication_Channel_for_Teacher,
      resources: [
        {
          response_option: CommunicationChannel.LMS,
          resource_name: "Getting Setup Communication Kits",
          resource_link:
            "https://support.newsela.com/article/teacher-rollout-kits/",
          todo_item: "Communications kit shared with teachers for LMS",
        },
      ],
    },
  ],
  resources: [
    {
      resource_name: "Enabling Newsela Emails",
      resource_link:
        "https://support.newsela.com/article/allow-staff-members-to-receive-newsela-emails/",
      todo_item: "Enabled Newsela Emails",
    },
  ],
};

export default communicationsForm;
